"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_redux_1 = require("react-redux");
var get_string_1 = tslib_1.__importDefault(require("./get-string"));
exports.mapStateToProps = function (state, _a) {
    var code = _a.code, replaceOptions = _a.replaceOptions;
    return ({
        translatedString: get_string_1.default(state, code, replaceOptions)
    });
};
exports.default = react_redux_1.connect(exports.mapStateToProps);
//# sourceMappingURL=enhancer.js.map